import React, { FC } from 'react'

interface CardSectionReasonProps {
    title: string
    descriptionNonBold?: string
    descriptionBold?: string
    subdescription?: string
    order: string
}

export const CardSectionReason: FC<CardSectionReasonProps> = ({ order, title, descriptionBold, descriptionNonBold, subdescription }) => {
    return (
        <div className='relative w-[299px] h-[240px] p-4 bg-white shadow-[4px_4px_6px_0px_#0D948838] px-6 text-center mt-8'>
            <div className='mx-auto mt-2 text-xl font-bold text-center'>
                <div className='w-10 h-10 mx-auto bg-accent-100 px-2 py-1 mt-2 md:px-4 sm:py-2 justify-center flex items-center rounded-full'>
                    <p className='text-white text-[9.5px] md:text-base font-body font-bold'>{order}</p>
                </div>
                    <h5 className='text-secondary-100 text-lg font-body font-bold'>{title}</h5>
                    <p className='mt-5 text-secondary-100 text-sm font-body font-bold'>{descriptionBold}</p>
                    <p className='text-secondary-100 text-sm font-body font-normal'>{subdescription}</p>
                    <p className='mt-5 text-secondary-100 text-sm font-body font-normal'>{descriptionNonBold}</p>
            </div>
        </div>
    )
}